module.exports = __webpack_public_path__ + "static/media/depositSlide2.f130d4bd.svg";